<template>
  <v-tr
    :isHover="isHover"
    @mouseover="changeHoverRecord">
    <v-td
      v-for="columnName in tableList"
      :key="columnName"
      :columnStyle="columnName | columnStyle(columnsWidth, columns)"
    >
      <info-render
        :full="data"
        :recordIndex="recordIndex"
        :data="data[columnName]"
        :column="columns[columnName]"
        :minLength="columns[columnName].minLength"
        :width="columnsWidth[columnName]"
      >
        <template slot-scope="props">
          <div
            v-if="columns[columnName].checkBox">
            <VCheckBox
              v-model="isCheck"
              :isCheckItem="true"
              :checked="isCheck"
              :checkBoxOptions="data"
              @checkValue="handleCheckItem">
            </VCheckBox>
          </div>
          <div v-if="columns[columnName].html" v-html="props.content"></div>
          <div v-else-if="columns[columnName].link" class="columns-render">
            <router-link :to="columns[columnName].link">
              <el-button type="text">{{ props.content }}</el-button>
            </router-link>
          </div>
          <div v-else>{{props.content}}</div>
        </template>
      </info-render>
    </v-td>
    <v-td
      v-if="operationList && operationList.length>0"
      :columnStyle="operationWidth | operationStyle">
      <ButtonList
        v-if="buttonList.length>0"
        :buttonList="buttonList"
      />
      <span v-else>
        -
      </span>
    </v-td>
  </v-tr>
</template>

<script>
import InfoRender from '@/components/InfoRender'
import VTbody from '@/components/VTable/VTbody'
import VTr from '@/components/VTable/VTr'
import VTd from '@/components/VTable/VTd'
import ButtonList from '@/components/ButtonList'
import VCheckBox from '@/components/VTable/VCheckBox'

export default {
  name: 'DataTableRecord',
  components: {
    InfoRender,
    VTbody,
    VTr,
    VTd,
    ButtonList,
    VCheckBox
  },
  props: {
    recordIndex: Array,
    mainColumn: String,
    operationList: Array,
    operationWidth: Number,
    columns: Object,
    columnsWidth: Object,
    isCheckBox: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 0
    },
    tableList: {
      type: Array,
      default: []
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hoverBy: {
      type: String,
      default: 'id'
    },
    hoverRecord: {
      type: String | Number
    },
    isCheckAll: Boolean
  },
  computed: {
    isHover () {
      return this.hoverRecord === this.data[this.hoverBy]
    },
    levelStyle () {
      return {
        'margin-left': this.level * 28 + 'px'
      }
    },
    buttonList () {
      return this.operationList.filter(operation => {
        return !operation.isShow || operation.isShow(this.data, operation)
      }).map(operation => {
        return {
          ...operation,
          size: 'xs',
          funcProps: {
            ...operation.funcProps,
            data: this.data
          }
        }
      })
    },
    isCheck () {
      return this.isCheckAll
    }
  },
  filters: {
    columnStyle (columnName, columnsWidth, columns) {
      return {
        width: columnsWidth[columnName] + 'px',
        ...columns[columnName].style
      }
    },
    operationStyle (width) {
      return {
        'width': width + 'px'
      }
    }
  },
  methods: {
    changeHoverRecord (val) {
      this.$emit('changeHoverRecord', this.data[this.hoverBy])
    },
    handleCheckItem (value, checked) {
      this.$emit('handleCheckItem', value, checked)
    }
  }
}
</script>

<style scoped lang="sass">
.fa
  width: 10px
</style>


// WEBPACK FOOTER //
// DataTableRecord.vue?6dc52d95